import React, { useState } from 'react'
import './Reminder.css';

function Reminder() {
    const [reminder, setReminder] = useState([]);
    const [newReminder, setNewReminder] = useState("");
    const handleInputChange =(event)=>{
setNewReminder(event.target.value)
    }
    const handleAddReminder=()=>{
if(newReminder.trim()){
    setReminder([...reminder,newReminder])
    setNewReminder("")
}
    }
    const handleDelete =(index)=>{
        setReminder(reminder.filter((item,itemIndex) =>itemIndex != index))

    }
  return (
    <div className='con'>
        <h1>Reminder App</h1>
        <div className='input-con'>

            <input type='text' value={newReminder} placeholder='Enter A Reminder' onChange={handleInputChange}/>
            <button className='add-btn' onClick={handleAddReminder}>Add Reminder</button>

        </div>
        {reminder.length >0 ?
        <ul className='remlist'>
            {
                reminder.map((reminder,index)=>(
                    <li key={{index}}>
                        {reminder}
                        <button onClick={()=>handleDelete(index)} className='dltbtn'>Delete</button>
                    </li>
                ))
            }

        </ul>: "No Reminder" }
    </div>
  )
}

export default Reminder